import { IconClose } from "app/components/Icon/Icon";
import { ReportTypes } from "app/utils/const";
import React, { useEffect, useState } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { FormattedMessage } from "react-intl";

type Props = {
  isReportListLoading: boolean;
  numberOfReports: number;
  query: string;
  resetParticipantSearch: (...args: Array<any>) => any;
  tab: string;
};

const ResultsCountContent: React.FC<Props> = props => {
  const {
    isReportListLoading,
    numberOfReports,
    resetParticipantSearch,
    query,
    tab,
  } = props;

  const [resultsCountContent, setResultsCountContent] = useState<
    React.ReactNode | null | undefined
  >(null);

  useEffect(() => {
    if (isReportListLoading) {
      setResultsCountContent(null);
    } else {
      if (query.length > 0) {
        setResultsCountContent(
          <div className="results-count__filter-message-container">
            <span className="results-count__filter-message">
              {numberOfReports} results matching your criteria: '{query}'
            </span>
            <div
              className="results-count__iconclose"
              onClick={resetParticipantSearch}
            >
              <IconClose />
            </div>
          </div>
        );
      } else {
        switch (tab) {
          case ReportTypes.CURRENT:
            setResultsCountContent(
              numberOfReports !== 1 ? (
                <span>
                  {numberOfReports}
                  <FormattedMessage tagName="span" id="bets-slip-open-bets" />
                </span>
              ) : (
                <span>
                  {numberOfReports}
                  <FormattedMessage tagName="span" id="bets-slip-open-bets" />
                </span>
              )
            );
            break;

          case ReportTypes.SETTLED:
            setResultsCountContent(
              numberOfReports !== 1 ? (
                <span>
                  {numberOfReports}{" "}
                  <FormattedMessage tagName="span" id="reports-settled-bets" />
                </span>
              ) : (
                <span>
                  {numberOfReports}{" "}
                  <FormattedMessage tagName="span" id="reports-settled-bet" />
                </span>
              )
            );
            break;

          case ReportTypes.TRANSACTIONS:
            setResultsCountContent(
              numberOfReports !== 1 ? (
                <span>
                  {numberOfReports}{" "}
                  <FormattedMessage tagName="span" id="reports-transactions" />
                </span>
              ) : (
                <span>
                  {numberOfReports}{" "}
                  <FormattedMessage tagName="span" id="reports-transaction" />
                </span>
              )
            );
            break;

          default:
            setResultsCountContent(null);
            break;
        }
      }
    }
  }, [
    isReportListLoading,
    numberOfReports,
    query,
    resetParticipantSearch,
    tab,
  ]);

  return <>{resultsCountContent}</>;
};

export default ResultsCountContent;
